import { Button, Stack, Text } from "@bookingcom/bui-react";
import { AlternativeFares } from "../AlternativeFares/AlternativeFares";
import React from "react";
import OrderStatus from "../ConfirmationInner/OrderStatus";
import useCheckoutAlternativeFaresController from "./useCheckoutAlternativeFares.controller";
import AlternativeFaresLegalMessages from "../AlternativeFares/AlternativeFaresLegalMessages";

const CheckoutAlternativeFaresDesktopInner = () => {
  const {
    alternativeFares,
    alternativeFaresLoading,
    alternativeFaresError,
    isSirfAvailable,
    title,
    subtitle,
    errorCta,
    onErrorClick
  } = useCheckoutAlternativeFaresController();

  return (
    <main role="main" id="basiclayout">
      <Stack gap={2}>
        <Stack gap={4}>
          <Stack>
            <OrderStatus status="ERROR" isPaymentCollection={false} />
            <Text tagName="h1" variant="headline_1">
              {title}
            </Text>

            {Array.isArray(subtitle) ? (
              <Stack gap={4}>
                {subtitle.map((s, i) => (
                  <Text key={i} variant="body_1">
                    {s}
                  </Text>
                ))}
              </Stack>
            ) : (
              <Text variant="body_1">{subtitle}</Text>
            )}
          </Stack>

          {alternativeFaresError ? (
            <div>
              <Button
                text={errorCta}
                iconPosition="start"
                variant="primary"
                type="button"
                size="medium"
                wide={false}
                onClick={onErrorClick}
              />
            </div>
          ) : (
            <AlternativeFares isLoading={alternativeFaresLoading} alternativeFares={alternativeFares} />
          )}
        </Stack>

        <AlternativeFaresLegalMessages active={!!alternativeFares.length} isSirfActive={isSirfAvailable} />
      </Stack>
    </main>
  );
};

export default CheckoutAlternativeFaresDesktopInner;
